import { escListener, scrollLock, trapFocus, removeTrapFocus } from "../utilities/utils"

import Overlay from "../utilities/overlay"

const overlay = new Overlay()

const pickupAvailability = document.querySelector(".pickup-availability")
const pickupAvailabilitySidebar = pickupAvailability.querySelector(".pickup-availability__sidebar")
const pickUpAvailabilityOpen = document.getElementById("pickup-availability-open")
const pickUpAvailabilityClose = document.getElementById("pickup-availability-close")

const open = () => {
  pickupAvailability.classList.add("open")
  document.body.classList.add("active", "minicart")
  escListener(true, close)
  scrollLock(true)
  pickUpAvailabilityClose.focus()
  overlay.open()
  overlay.onClick(close)
  trapFocus(pickupAvailability, pickupAvailabilitySidebar)
}

const close = () => {
  pickupAvailability.classList.remove("open")
  document.body.classList.remove("active", "minicart")
  scrollLock(false)
  overlay.removeOnClick(close)
  overlay.close()
  removeTrapFocus(pickupAvailability)
}

if (pickUpAvailabilityOpen) {
  document.getElementById("pickup-availability-open").addEventListener("click", open)
}

if (pickUpAvailabilityClose) {
  document.getElementById("pickup-availability-close").addEventListener("click", close)
}
